import * as React from 'react';

const SvgIntroAccepted = (props) => (
  <svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_967_3969)">
      <circle cx={21} cy={18} r={12} fill="#28C900" />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.3333 14.6667C23.3333 16.1394 22.1394 17.3333 20.6667 17.3333C19.1939 17.3333 18 16.1394 18 14.6667C18 13.1939 19.1939 12 20.6667 12C22.1394 12 23.3333 13.1939 23.3333 14.6667ZM25.3333 21.3333C25.3333 22.8061 23.244 24 20.6667 24C18.0893 24 16 22.8061 16 21.3333C16 19.8606 18.0893 18.6667 20.6667 18.6667C23.244 18.6667 25.3333 19.8606 25.3333 21.3333ZM26 18.5C25.7239 18.5 25.5 18.2761 25.5 18V17.1667H24.6667C24.3905 17.1667 24.1667 16.9428 24.1667 16.6667C24.1667 16.3905 24.3905 16.1667 24.6667 16.1667H25.5V15.3333C25.5 15.0572 25.7239 14.8333 26 14.8333C26.2761 14.8333 26.5 15.0572 26.5 15.3333V16.1667H27.3333C27.6095 16.1667 27.8333 16.3905 27.8333 16.6667C27.8333 16.9428 27.6095 17.1667 27.3333 17.1667H26.5V18C26.5 18.2761 26.2761 18.5 26 18.5Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_967_3969"
        x={0}
        y={0}
        width={42}
        height={42}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius={1}
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_967_3969"
        />
        <feOffset dy={3} />
        <feGaussianBlur stdDeviation={4} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_967_3969"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_967_3969"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default SvgIntroAccepted;
